import { colors, scale, breakpoint } from "@capioweb/ui-components"
import styled from "styled-components"

export const FormContainer = styled.div`
	width: 100%;
	padding: ${scale.px(4)} ${scale.px(3)};
	background-color: ${colors.greyF3};

	${breakpoint("m")`
        border-radius: ${scale.px(3)};
    `}
`
